export default __webpack_public_path__ + "static/media/DialSvg.c758f375.svg";